export default __webpack_public_path__ + "static/blob-18-f9657aa3c47eaf230496f3073182c471.svg";